export default "__VITE_ASSET__CI3po7kU__ 100w";